import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium';
import { Status } from '../../../hooks/useFetch';

export interface IReadOnlyGridDialogProps {
    open: boolean;
    title: string;
    rows: any[];
    columns: GridColDef[];
    status?: Status;
    onClose: () => void;
}

/** Popup with a search field above a read-only grid. */
function ReadOnlyGridDialog(props: IReadOnlyGridDialogProps) {
    const { open, title, rows, columns, status, onClose } = props;
    const [search, setSearch] = useState('');

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='lg' TransitionProps={{ onExited: () => setSearch('') }}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <TextField fullWidth size='small' placeholder='Search' value={search} onChange={e => setSearch(e.target.value)}
                    sx={{ mb: 2, mt: 1 }} />
                <DataGridPremium
                    autoHeight
                    rows={rows}
                    columns={columns}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 1 ? 'tui-grid-alternate-row' : ''}
                    loading={status === Status.Fetching || status === Status.Idle}
                    filterModel={{ items: [], quickFilterValues: search.split(' ').filter(Boolean) }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

export default ReadOnlyGridDialog;
